import classNames from 'classnames';

import { ShimmerCardTileLoader } from '@testsigma/atoms';

import { DeleteConnectionModalHeader } from '../delete/header';

const LinkedEntitiesLoadingScreen: React.FC = () => {
  return (
    <div className={classNames('flex gap-x-6 flex-row')}>
      <DeleteConnectionModalHeader />

      <div className='flex-1'>
        <ShimmerCardTileLoader cardClassName='!border-none !mb-0 !p-0' />
      </div>
    </div>
  );
};

export { LinkedEntitiesLoadingScreen };
